const RARITY_BG = {
  legendary: "linear-gradient(145deg, #b8860b 0%, #d4a017 25%, #f5c842 55%, #e8a800 80%, #a07010 100%)",
  rare:      "linear-gradient(145deg, #1a3a6e 0%, #1e5298 30%, #2d7dd2 60%, #1a5fa0 85%, #0d2f5c 100%)",
  epic:      "linear-gradient(145deg, #4a1a7a 0%, #7b2dbe 35%, #9b4de0 60%, #6a22a8 85%, #321258 100%)",
  common:    "linear-gradient(145deg, #2d3a4a 0%, #445566 35%, #5a7088 60%, #3a4e60 85%, #1e2c38 100%)",
};

export default function Collectible({ src, name, number, rarity = "legendary", size = 110, className = "", onClick }) {
  const bg = RARITY_BG[rarity] || RARITY_BG.legendary;

  return (
    <button
      type="button"
      className={`collectible-card ${className}`}
      style={size != null ? { "--card-size": `${size}px` } : {}}
      title={name}
      onClick={onClick}
    >
      {/* Background */}
      <span className="collectible-card__bg" style={{ background: bg }} aria-hidden="true" />

      {/* Number badge */}
      {number != null && (
        <span className="collectible-card__num">#{number}</span>
      )}

      {/* Coin image */}
      <img src={src} alt={name} className="collectible-card__img" draggable={false} />

      {/* Shimmer sweep */}
      <span className="collectible-card__shimmer" aria-hidden="true" />
    </button>
  );
}
